import { useGetApOfficeAiSettingSuspense } from 'ap-openapi';
import { useMemo } from 'react';
import type { AiService, AiServiceSettingResponse } from './type';

export type { AiServiceSettingResponse } from './type';

export const useGetAiServiceSetting = (): AiServiceSettingResponse => {
  const { data } = useGetApOfficeAiSettingSuspense();

  return useMemo(() => {
    const {
      ai_service_settings,
      is_ai_service_agreed,
      is_model_training_allowed,
    } = data.data;

    const services: AiService[] = ai_service_settings.map(
      ({ description, name, service_type }) => ({
        description,
        name,
        service_type,
      })
    );

    return {
      ai_service_settings: services,
      is_ai_service_agreed,
      is_model_training_allowed,
    };
  }, [data]);
};
